import { stats } from '@fiverr-private/obs';

/**
 * Metrics of the package.
 * @enum {String}
 */
export const METRICS = {
    API_FETCH_IOS_REVIEWS_ERROR: 'api.fetch.ios.reviews.error'
};

/**
 * Increment the count of a given metric.
 * @param {String} metric - The metric to send.
 */
export const count = (metric) => {
    stats.count('mobile_app_banner_package', metric);
};
